<template>
  <div class="flex gap-4 overflow-scroll md:overflow-auto md:grid md:flex-wrap md:grid-cols-2 lg:grid-cols-3 last:mr-0">
    <PromotionTrackingWrapper v-for="(banner, index) in data" :key="index" :content="banner">
      <RandomBanner :content="banner" />
    </PromotionTrackingWrapper>
  </div>
</template>

<script setup lang="ts">
type Props = {
  content: any;
};

const props = withDefaults(defineProps<Props>(), {
  content: () => ({}),
});

const { data } = useLazyAsyncData(
  () => {
    const banners = [...(props.content.fields?.randomBanners || [])];
    for (let i = banners.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [banners[i], banners[j]] = [banners[j], banners[i]];
    }
    return Promise.resolve(banners.slice(0, 6));
  },
  {
    default: () => [],
  },
);
</script>

<script lang="ts">
export default defineComponent({
  name: 'RandomBanners',
});
</script>
